var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-popover',{attrs:{"disabled":_vm.disabled,"placement":"top","trigger":"hover","popper-class":"pop-Style"}},[_c('div',{staticClass:"realValue"},[_vm._v(_vm._s(_vm.real_value))]),_c('span',{ref:"table-pop-content",staticClass:"span-ellipsis",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(" "+_vm._s(_vm.real_value)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }